(function () {
  'use strict';

  function parseAttr(el, name, fallback) {
    try {
      var raw = el.getAttribute(name);
      if (!raw) return fallback;
      var ta = document.createElement('textarea');
      ta.innerHTML = raw;
      return JSON.parse(ta.value);
    } catch (e) {
      return fallback;
    }
  }

  function qs(name) {
    try {
      return new URLSearchParams(window.location.search).get(name);
    } catch (e) {
      return null;
    }
  }

  function pmc() {
    return window.PhoneMagneticCompat || null;
  }

  function readJson(response) {
    return response.text().then(function (text) {
      var trimmed = String(text || '').replace(/^\uFEFF/, '').trim();
      if (!trimmed || trimmed.charAt(0) === '<') {
        throw new Error(
          /verifying your connection|just a moment/i.test(trimmed || '')
            ? 'Store security check interrupted the cart. Refresh and try again.'
            : 'Cart unavailable. Refresh and try again.'
        );
      }
      return JSON.parse(trimmed);
    });
  }

  function cartGet() {
    var api = pmc();
    if (api && typeof api.fetchCartJson === 'function') return api.fetchCartJson();
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    }).then(function (r) {
      return readJson(r).then(function (j) {
        if (!r.ok) throw new Error((j && (j.description || j.message)) || 'Cart request failed');
        return j;
      });
    });
  }

  function discountApplied(cart, code) {
    var needle = String(code || 'CASE15').toUpperCase();
    var apps = (cart && cart.cart_level_discount_applications) || [];
    for (var i = 0; i < apps.length; i++) {
      var t = String(apps[i].title || apps[i].code || '').toUpperCase();
      if (t.indexOf(needle) !== -1 || t.indexOf('CASE') !== -1) return true;
    }
    var items = (cart && cart.items) || [];
    for (var j = 0; j < items.length; j++) {
      var allocs = items[j].discounts || items[j].line_level_discount_allocations || [];
      for (var k = 0; k < allocs.length; k++) {
        var a = allocs[k];
        var title = String((a.discount_application && a.discount_application.title) || a.title || '').toUpperCase();
        if (title.indexOf(needle) !== -1 || title.indexOf('CASE') !== -1 || title.indexOf('15%') !== -1) {
          return true;
        }
      }
    }
    return Number(cart && cart.total_discount) > 0 && hasBankAndCase(cart);
  }

  function hasBankAndCase(cart) {
    var bank = false;
    var caseItem = false;
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var h = items[i].handle || '';
      if (h.indexOf('power-bank-magsafe') !== -1) bank = true;
      if (
        h.indexOf('power-bank') === -1 &&
        /case|phone-case|magnetic|magsafe|kickstand/i.test(h + ' ' + (items[i].title || ''))
      ) {
        caseItem = true;
      }
    }
    return bank && caseItem;
  }

  function previewUrl(v) {
    if (!v) return '';
    return v.image || v.thumb || '';
  }

  var BANK_TIERS = [
    { qty: 1, pct: 0, badge: 'Single' },
    { qty: 2, pct: 0.15, badge: '15% off' },
    { qty: 3, pct: 0.2, badge: '20% off' },
    { qty: 4, pct: 0.25, badge: '25% off', plus: true },
  ];
  var BANK_MAX_PACK = 8;

  function bankTierPct(qty) {
    var n = Number(qty) || 1;
    if (n >= 4) return 0.25;
    if (n >= 3) return 0.2;
    if (n >= 2) return 0.15;
    return 0;
  }

  function moneyFromPoundsString(priceStr, qty, pct) {
    var unitCents = Math.round(parseFloat(String(priceStr || '0').replace(/,/g, '')) * 100);
    if (!isFinite(unitCents)) unitCents = 0;
    var saleUnit = Math.floor(unitCents * (1 - (Number(pct) || 0)));
    var total = saleUnit * (Number(qty) || 1);
    var pounds = total / 100;
    try {
      return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(pounds);
    } catch (e) {
      return '£' + pounds.toFixed(2);
    }
  }

  var paintGen = 0;

  function bumpCartBubble(cart) {
    var api = pmc();
    if (api && typeof api.updateCartBubble === 'function') {
      api.updateCartBubble(cart);
      return;
    }
    var count = cart && cart.item_count != null ? Number(cart.item_count) : null;
    if (count == null || !isFinite(count)) return;
    try {
      var icons = document.querySelectorAll('cart-icon');
      if (icons.length) {
        icons.forEach(function (icon) {
          if (typeof icon.renderCartBubble === 'function') icon.renderCartBubble(count, true);
        });
        return;
      }
    } catch (e) {}
    document.querySelectorAll('.cart-bubble__text-count').forEach(function (el) {
      el.textContent = count < 100 ? String(count) : '';
      el.classList.toggle('hidden', count === 0);
    });
    document.querySelectorAll('.cart-bubble').forEach(function (el) {
      el.classList.toggle('visually-hidden', count === 0);
      el.classList.remove('cart-bubble--animating');
    });
  }

  /**
   * Soft-refresh drawer markup. Serialized by paintGen so an older fetch never
   * overwrites a newer cart paint (that looked like “updates once then stops”).
   */
  function paintCartVisual(cart) {
    bumpCartBubble(cart);
    var gen = ++paintGen;
    var api = pmc();

    function applyIfCurrent(sections) {
      if (gen !== paintGen) return null;
      if (!sections || !Object.keys(sections).length) return null;
      if (api && typeof api.applySectionsHtml === 'function') {
        api.applySectionsHtml(sections);
      }
      return sections;
    }

    var fetchP;
    if (api && typeof api.fetchCartSections === 'function') {
      fetchP = api.fetchCartSections();
    } else {
      fetchP = fetch('/?sections=cart-drawer-section', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      }).then(function (r) {
        return readJson(r);
      });
    }

    return fetchP.then(applyIfCurrent).catch(function () {
      return null;
    });
  }

  function cartAddItems(items) {
    var api = pmc();
    if (api && typeof api.cartAdd === 'function') return api.cartAdd(items);
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items }),
    }).then(function (r) {
      return readJson(r).then(function (j) {
        if (!r.ok) throw new Error((j && (j.description || j.message)) || 'Could not add');
        return j;
      });
    });
  }

  function cartUpdateLines(updates) {
    var api = pmc();
    if (api && typeof api.cartUpdate === 'function') return api.cartUpdate(updates);
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates }),
    }).then(function (r) {
      return readJson(r).then(function (j) {
        if (!r.ok) throw new Error((j && (j.description || j.message)) || 'Could not update cart');
        return j;
      });
    });
  }

  /**
   * Quiet mix sync: desired variantId → qty for power banks.
   * No section morph / cart:refresh.
   */
  function syncBankMix(bankHandle, desiredCounts) {
    var desired = {};
    Object.keys(desiredCounts || {}).forEach(function (vid) {
      var q = Number(desiredCounts[vid]) || 0;
      if (q > 0) desired[String(vid)] = q;
    });

    return cartGet()
      .then(function (cart) {
        var updates = {};
        var inCart = {};
        var items = cart.items || [];
        for (var i = 0; i < items.length; i++) {
          if (items[i].handle !== bankHandle) continue;
          var vid = String(items[i].variant_id || items[i].id);
          inCart[vid] = Number(items[i].quantity) || 0;
          updates[vid] = desired[vid] || 0;
        }

        var toAdd = [];
        Object.keys(desired).forEach(function (vid) {
          if (inCart[vid] != null) {
            updates[vid] = desired[vid];
          } else {
            toAdd.push({ id: Number(vid), quantity: desired[vid] });
          }
        });

        var same = true;
        Object.keys(updates).forEach(function (vid) {
          if ((inCart[vid] || 0) !== (updates[vid] || 0)) same = false;
        });
        if (same && !toAdd.length) return cart;

        var chain = Object.keys(updates).length
          ? cartUpdateLines(updates)
          : Promise.resolve();
        return chain.then(function () {
          if (!toAdd.length) return cartGet();
          return cartAddItems(toAdd).then(function () {
            return cartGet();
          });
        });
      })
      .then(function (cart) {
        document.dispatchEvent(
          new CustomEvent('cart:update', { detail: { quiet: true, context: 'case15-deal' } })
        );
        return cart;
      });
  }

  function initRoot(root) {
    var code = root.getAttribute('data-discount-code') || 'CASE15';
    var bankHandle = root.getAttribute('data-bank-handle');
    var variants = parseAttr(root, 'data-bank-variants', []);
    var defaultColour = root.getAttribute('data-default-colour') || 'Green';
    var colourParam = qs('colour');
    var startColour = colourParam || defaultColour;
    if (!variants.some(function (v) {
      return String(v.colour).toLowerCase() === String(startColour).toLowerCase();
    })) {
      startColour = (variants[0] && variants[0].colour) || defaultColour;
    }

    var bankStatus = root.querySelector('[data-c15-bank-status]');
    var bankImg = root.querySelector('[data-c15-bank-img]');
    var codeBanner = root.querySelector('[data-c15-code-banner]');
    var codeNote = root.querySelector('[data-c15-code-note]');
    var cartLink = root.querySelector('[data-c15-cart-link]');
    var packQtyEl = root.querySelector('[data-c15-pack-qty]');
    var packMoreEl = root.querySelector('[data-c15-pack-more]');
    var packSlotsEl = root.querySelector('[data-c15-pack-slots]');
    var packPriceEl = root.querySelector('[data-c15-pack-price]');
    var atcBtn = root.querySelector('[data-c15-bank-atc]');
    var nextEl = root.querySelector('[data-c15-next]');
    var continueCaseBtn = root.querySelector('[data-c15-continue-case]');
    var step2 = root.querySelector('[data-c15-step="2"]');

    var packSize = Math.max(1, Math.min(BANK_MAX_PACK, Number(qs('qty')) || 1));
    var picks = [];
    var activeSlot = 0;
    var banksInCart = false;
    var adding = false;

    function fillPicks() {
      var fill = picks.length ? picks[picks.length - 1] : startColour;
      while (picks.length < packSize) picks.push(fill);
      if (picks.length > packSize) picks = picks.slice(0, packSize);
      if (activeSlot >= packSize) activeSlot = Math.max(0, packSize - 1);
    }
    fillPicks();

    function bankSwatchStyle(colour) {
      var api = pmc();
      if (api && typeof api.swatchStyle === 'function') return api.swatchStyle(colour);
      var n = String(colour || '').toLowerCase();
      var map = {
        black: '#1a1a1a',
        green: '#3d7a4a',
        purple: '#6b4c9a',
        white: '#f2f2f2',
      };
      return 'background-color:' + (map[n] || '#d0d0d0');
    }

    if (cartLink) {
      cartLink.href = '/cart';
    }

    function markDealOptOut() {
      try {
        sessionStorage.setItem('c15-skip-case-deal', '1');
        sessionStorage.setItem('magsafe-case-upsell-dismissed', '1');
      } catch (e) {}
    }

    function showPostAddActions() {
      if (nextEl) {
        nextEl.hidden = false;
        try {
          nextEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        } catch (e) {}
      }
    }

    function goToCaseStep() {
      if (step2) {
        try {
          step2.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } catch (e) {
          step2.scrollIntoView(true);
        }
        step2.classList.add('is-active');
      }
    }

    function variantForColour(colour) {
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].colour).toLowerCase() === String(colour).toLowerCase()) return variants[i];
      }
      return variants[0] || null;
    }

    function setBankPreview(colour) {
      var v = variantForColour(colour);
      var url = previewUrl(v);
      if (!bankImg || !url) return;
      bankImg.src = url;
      bankImg.alt = (v.colour || 'MagSafe') + ' MagSafe power bank';
    }

    function setCodeApplied(applied) {
      if (!codeBanner) return;
      codeBanner.classList.toggle('is-applied', !!applied);
      if (codeNote) {
        codeNote.textContent = applied ? 'Applied' : 'Case 15% off · optional';
      }
    }

    function refreshDealState() {
      return cartGet().then(function (cart) {
        setCodeApplied(discountApplied(cart, code));
        return cart;
      });
    }

    function countsFromPicks() {
      var counts = {};
      for (var i = 0; i < picks.length; i++) {
        var v = variantForColour(picks[i]);
        if (!v) continue;
        var id = String(v.id);
        counts[id] = (counts[id] || 0) + 1;
      }
      return counts;
    }

    function packSummaryText() {
      var n = picks.length || 1;
      var pct = bankTierPct(n);
      var unique = [];
      picks.forEach(function (c) {
        if (unique.indexOf(c) === -1) unique.push(c);
      });
      var mix =
        unique.length === 1
          ? unique[0]
          : unique.length <= 3
            ? unique.join(' + ')
            : unique.length + ' colours';
      var noun = n === 1 ? 'power bank' : 'power banks';
      var base = n + ' ' + noun + ' · ' + mix;
      if (pct > 0) base += ' · ' + Math.round(pct * 100) + '% off banks';
      return base;
    }

    function bankStatusText() {
      if (banksInCart) return packSummaryText() + ' · in cart';
      return packSummaryText();
    }

    function refreshAtcLabel() {
      if (!atcBtn || adding) return;
      atcBtn.textContent = banksInCart ? 'Update cart' : 'Add to cart';
      atcBtn.classList.toggle('is-added', !!banksInCart);
    }

    function updatePackPrice() {
      if (!packPriceEl) return;
      var v = variantForColour(picks[0] || startColour);
      if (!v) {
        packPriceEl.textContent = '';
        return;
      }
      var pct = bankTierPct(packSize);
      var total = moneyFromPoundsString(v.price, packSize, pct);
      if (packSize === 1 || pct === 0) {
        packPriceEl.textContent = total;
      } else {
        packPriceEl.textContent = total + ' · ' + Math.round(pct * 100) + '% off';
      }
    }

    function renderSlots() {
      if (!packSlotsEl) return;
      packSlotsEl.innerHTML = '';
      for (var i = 0; i < packSize; i++) {
        (function (slotIndex) {
          var slot = document.createElement('div');
          slot.className = 'c15__slot';
          var label = document.createElement('p');
          label.className = 'c15__slot-label';
          var colourName = picks[slotIndex] || '';
          label.innerHTML =
            (packSize === 1 ? 'Colour' : 'Bank ' + (slotIndex + 1)) +
            ' <strong>' +
            colourName +
            '</strong>';
          var swatches = document.createElement('div');
          swatches.className = 'c15__slot-swatches';
          swatches.setAttribute('role', 'radiogroup');
          swatches.setAttribute(
            'aria-label',
            (packSize === 1 ? 'Power bank colour' : 'Bank ' + (slotIndex + 1) + ' colour') +
              (colourName ? ', selected ' + colourName : '')
          );

          variants.forEach(function (v) {
            var selected = v.colour === picks[slotIndex];
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'c15__swatch' + (selected ? ' is-selected' : '');
            btn.disabled = !v.available;
            btn.setAttribute('aria-pressed', selected ? 'true' : 'false');
            btn.setAttribute('aria-label', selected ? v.colour + ' selected' : v.colour);
            btn.title = selected ? v.colour + ' (selected)' : v.colour;
            btn.setAttribute('style', bankSwatchStyle(v.colour));
            btn.addEventListener('click', function () {
              picks[slotIndex] = v.colour;
              activeSlot = slotIndex;
              setBankPreview(v.colour);
              renderSlots();
              updatePackPrice();
              refreshAtcLabel();
              if (bankStatus) bankStatus.textContent = bankStatusText();
            });
            swatches.appendChild(btn);
          });

          slot.appendChild(label);
          slot.appendChild(swatches);
          packSlotsEl.appendChild(slot);
        })(i);
      }
    }

    function renderPack() {
      if (!packQtyEl) return;
      packQtyEl.innerHTML = '';
      BANK_TIERS.forEach(function (tier) {
        var pressed = tier.plus ? packSize >= tier.qty : packSize === tier.qty;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'c15__pack-btn';
        btn.setAttribute('aria-pressed', pressed ? 'true' : 'false');
        btn.innerHTML =
          '<strong>' +
          (tier.plus ? (packSize >= tier.qty ? String(packSize) : tier.qty + '+') : String(tier.qty)) +
          '</strong><span>' +
          tier.badge +
          '</span>';
        btn.addEventListener('click', function () {
          if (tier.plus) setPackSize(packSize >= tier.qty ? packSize : tier.qty);
          else setPackSize(tier.qty);
        });
        packQtyEl.appendChild(btn);
      });

      if (packMoreEl) {
        if (packSize < 4) {
          packMoreEl.hidden = true;
          packMoreEl.innerHTML = '';
        } else {
          packMoreEl.hidden = false;
          packMoreEl.innerHTML = '';
          var minus = document.createElement('button');
          minus.type = 'button';
          minus.className = 'c15__pack-step';
          minus.setAttribute('aria-label', 'Fewer power banks');
          minus.textContent = '−';
          minus.disabled = packSize <= 4;
          minus.addEventListener('click', function () {
            if (packSize <= 4) return;
            setPackSize(packSize - 1);
          });
          var label = document.createElement('span');
          label.className = 'c15__pack-more-label';
          label.textContent = packSize + ' banks';
          var plus = document.createElement('button');
          plus.type = 'button';
          plus.className = 'c15__pack-step';
          plus.setAttribute('aria-label', 'More power banks');
          plus.textContent = '+';
          plus.disabled = packSize >= BANK_MAX_PACK;
          plus.addEventListener('click', function () {
            if (packSize >= BANK_MAX_PACK) return;
            setPackSize(packSize + 1);
          });
          packMoreEl.appendChild(minus);
          packMoreEl.appendChild(label);
          packMoreEl.appendChild(plus);
        }
      }
      renderSlots();
      updatePackPrice();
    }

    function setPackSize(next) {
      packSize = Math.max(1, Math.min(BANK_MAX_PACK, Number(next) || 1));
      fillPicks();
      setBankPreview(picks[activeSlot] || picks[0]);
      renderPack();
      refreshAtcLabel();
      if (bankStatus) bankStatus.textContent = bankStatusText();
    }

    function addBanksToCart() {
      if (adding) return Promise.resolve(null);
      fillPicks();
      var want = countsFromPicks();
      if (!Object.keys(want).length) {
        if (bankStatus) bankStatus.textContent = 'That colour is unavailable.';
        return Promise.resolve(null);
      }
      adding = true;
      if (atcBtn) {
        atcBtn.disabled = true;
        atcBtn.textContent = banksInCart ? 'Updating…' : 'Adding…';
      }
      if (bankStatus) bankStatus.textContent = banksInCart ? 'Updating…' : 'Adding…';

      return syncBankMix(bankHandle, want)
        .then(function (cart) {
          banksInCart = true;
          return paintCartVisual(cart).then(function () {
            return refreshDealState();
          });
        })
        .then(function () {
          if (bankStatus) bankStatus.textContent = bankStatusText();
          showPostAddActions();
          // Don't auto-open the cart drawer — on mobile the case upsell feels forced.
        })
        .catch(function (err) {
          if (bankStatus) {
            bankStatus.textContent = (err && err.message) || 'Could not add power bank.';
          }
        })
        .finally(function () {
          adding = false;
          if (atcBtn) atcBtn.disabled = false;
          refreshAtcLabel();
        });
    }

    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        addBanksToCart();
      });
    }

    if (continueCaseBtn) {
      continueCaseBtn.addEventListener('click', function () {
        goToCaseStep();
      });
    }

    root.querySelectorAll('[data-c15-skip-deal]').forEach(function (el) {
      el.addEventListener('click', function () {
        markDealOptOut();
      });
    });

    root.addEventListener(
      'click',
      function (ev) {
        var addBtn =
          ev.target &&
          ev.target.closest &&
          ev.target.closest('[data-pmc-add-variant], [data-pmc-add-with-bank], .mcu__card');
        if (!addBtn) return;
        setTimeout(function () {
          refreshDealState().then(function (cart) {
            if (discountApplied(cart, code) || hasBankAndCase(cart)) {
              setCodeApplied(true);
            }
          });
        }, 900);
      },
      true
    );

    document.addEventListener('cart:update', function () {
      refreshDealState();
    });
    document.addEventListener('shopify:cart:lines-update', function (event) {
      var promise = event && event.promise;
      if (promise && typeof promise.then === 'function') {
        promise
          .then(function () {
            refreshDealState();
          })
          .catch(function () {});
      } else {
        refreshDealState();
      }
    });

    setBankPreview(picks[0]);
    renderPack();
    refreshAtcLabel();
    if (bankStatus) bankStatus.textContent = bankStatusText();
    if (pmc() && typeof pmc().autoInit === 'function') {
      pmc().autoInit();
    }

    // Info tips: hover on desktop; tap toggle on touch.
    root.querySelectorAll('[data-c15-info]').forEach(function (btn) {
      var wrap = btn.closest('.c15__info');
      if (!wrap) return;
      btn.addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        var open = !wrap.classList.contains('is-open');
        root.querySelectorAll('.c15__info.is-open').forEach(function (el) {
          el.classList.remove('is-open');
          var b = el.querySelector('[data-c15-info]');
          if (b) b.setAttribute('aria-expanded', 'false');
        });
        if (open) {
          wrap.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
    document.addEventListener('click', function (ev) {
      if (ev.target && ev.target.closest && ev.target.closest('.c15__info')) return;
      root.querySelectorAll('.c15__info.is-open').forEach(function (el) {
        el.classList.remove('is-open');
        var b = el.querySelector('[data-c15-info]');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    });
  }

  document.querySelectorAll('[data-case15-deal]').forEach(initRoot);
})();
